import api from "./api";
import { getToken } from "./auth";

// Opens a backend URL in a new tab with the JWT appended as a query param so
// the auth middleware can authenticate the request. Use this for PDF/file
// endpoints that the user opens directly via window.open — those calls don't
// go through axios, so the Authorization header isn't applied automatically.
//
// Pass either:
//   - an API path beginning with "/" (e.g. "/saleInvoices/123/pdf")
//   - or a fully-qualified URL (e.g. "http://host:5000/api/...")
//   - or just an endpoint relative to the API base (e.g. "pdfReports/saleInvoices?from=...")
export function openAuthPdf(target) {
  const token = getToken();
  const base = api.defaults.baseURL || "";
  let url;
  if (/^https?:\/\//i.test(target)) {
    url = target;
  } else if (target.startsWith("/")) {
    url = `${base}${target}`;
  } else {
    url = `${base}/${target}`;
  }
  if (token) {
    const sep = url.includes("?") ? "&" : "?";
    url = `${url}${sep}token=${encodeURIComponent(token)}`;
  }
  const w = window.open(url, "_blank");
  if (w) w.focus();
  else alert("Popup blocked. Allow popups for this site.");
  return w;
}
